export default function ScoreRing({ score = 0, size = 176, stroke = 12, label = "Overall" }) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, score));
  const offset = circumference - (clamped / 100) * circumference;

  const color =
    clamped >= 75 ? "text-[hsl(var(--success))]"
    : clamped >= 50 ? "text-[hsl(var(--warning))]"
    : "text-[hsl(var(--destructive))]";

  return (
    <div className="flex flex-col items-center" data-testid="score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="score-ring">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="hsl(var(--border))"
            strokeWidth={stroke}
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            className={color}
            stroke="currentColor"
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 800ms ease-out" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`font-heading font-extrabold text-5xl ${color}`} data-testid="score-value">
            {clamped}
          </span>
          <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground mt-1">{label}</span>
        </div>
      </div>
    </div>
  );
}
